
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, CanLoad, Route, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthorizationGuard } from 'src/app/routing/guards';
import { environment as ENV } from 'src/environments/environment';

class RootGuard implements CanLoad, CanActivate {

	private _authorization: AuthorizationGuard;
	constructor(private router: Router, authorization: AuthorizationGuard) {
		this._authorization = authorization;
	}
	
	canLoad(route: Route): Observable<boolean>|boolean {
		var canLoad = this._authorization.canLoad( route); 
		
		return canLoad;
	}
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|boolean {
		var canActivate =  this._authorization.canActivate(route, state); 

		return canActivate;
	}

}

class AirplaneMode implements CanLoad, CanActivate {
	
	canLoad(route: Route): Observable<boolean>|boolean {
		return true;
	}
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|boolean {
		return true;
	}
	
}

@Injectable()
class RouteGuardService implements CanLoad, CanActivate {
	private guard: RootGuard|AirplaneMode;
	
	constructor(private router: Router, authorization: AuthorizationGuard) {
		this.init(router, authorization);
	}
	init(router: Router, authorization: AuthorizationGuard) {
		if (ENV.type === 'MOCK') return this.guard = new AirplaneMode();
		this.guard = new RootGuard(router, authorization);
	}
	
	canLoad(route: Route): Observable<boolean>|boolean {
		return this.guard.canLoad(route);
	}
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|boolean {
		return this.guard.canActivate(route, state);
	}
	
}

export { RouteGuardService, RootGuard, AirplaneMode };
